export default __webpack_public_path__ + "static/media/ui.e6324de2.svg";